import { GatewayInputDataTypeEnum } from 'src/types/gateways';

const DISCRETE_DATA_TYPES: string[] = [
  GatewayInputDataTypeEnum.ALARM,
  GatewayInputDataTypeEnum.STATE,
  GatewayInputDataTypeEnum.MODE,
  GatewayInputDataTypeEnum.SETPOINT,
];

/**
 * Discrete tag types (alarms, states, modes, setpoints) should be fetched as
 * on-change data and rendered as a stepped line so high/low conditions stay visible.
 */
export const isDiscreteDataType = (dataType?: string): boolean =>
  !!dataType && DISCRETE_DATA_TYPES.includes(dataType.toLowerCase());
